import { NavLink } from "react-router-dom";

import style from "./navigation.module.css";

const HomeLink = ({ expanded }) => {
  return (
    <>
      <NavLink to="/" className={style.homeLink}>
        {expanded ? (
          <img src="/logotype.png" alt="JNG Baldai logotype" height={40} />
        ) : (
          <img src="/logo.png" alt="JNG Baldai logo" height={40} />
        )}
      </NavLink>
    </>
  );
};

export default HomeLink;
